import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
declare var $ :any;
@Component({
	selector: 'component-tab',
	templateUrl: './component.tab.html',
	styleUrls: ['./component.tab.css']
})
export class ComponentTab implements OnInit, AfterViewInit {

	@Input() tabList : any
	@Input() className : string
	@Input() tabNum : number
	@Output() onTabIndex = new EventEmitter<any>();


    ngOnInit() {
		
	}
		
	ngAfterViewInit(){
		if(this.tabNum == 0){
			$("#slide").addClass("left")
		}else if(this.tabNum == 1){
			$("#slide").addClass("right")
		}
	}

	tab(i){
		this.onTabIndex.emit(i)
		this.tabNum = i
		$("#slide").removeClass("left")
		$("#slide").removeClass("right")
		if(i===0){
			$("#slide").addClass("slide0")
			$("#slide").removeClass("slide1")
		}else if(i===1){
			$("#slide").addClass("slide1")
			$("#slide").removeClass("slide0")
		}
	}
}


// WEBPACK FOOTER //
// ./src/component/tab/component.tab.ts